const LOCAL_STORAGE_KEY = 'recentlyVisited';

export type RecentlyVisitedProduct = {
  type: 'product';
  date: number;
  id: number;
};

export type RecentlyVisitedProductCollection = {
  type: 'productCollection';
  date: number;
  id: string;
  slug: string;
  url: string;
};

export type RecentlyVisitedItem =
  | RecentlyVisitedProduct
  | RecentlyVisitedProductCollection;

const withLocalStorage = (cb: (localStorage: Storage) => void) => {
  try {
    if (IS_SERVER || !window.localStorage) {
      // There is no localStorage on the server, and localStorage can be null if
      // disabled in the browser.
      return null;
    }
    return cb(window.localStorage);
  } catch (e) {
    // localStorage may throw an exception when disabled; just ignore it.
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('Error occurred in withLocalStorage:', e);
    }
  }
  return null;
};

export const readRecentlyVisited = (): RecentlyVisitedItem[] => {
  const jsonString = withLocalStorage(localStorage =>
    localStorage.getItem(LOCAL_STORAGE_KEY)
  );

  if (!jsonString) {
    return [];
  }

  try {
    const data = JSON.parse(jsonString);
    return data && Array.isArray(data) ? data : [];
  } catch (e) {
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.warn('Could not parse recent visits from localStorage:', e);
    }
    return [];
  }
};

export const writeRecentlyVisited = (data: unknown) => {
  const jsonString = JSON.stringify(data);
  withLocalStorage(localStorage => {
    localStorage.setItem(LOCAL_STORAGE_KEY, jsonString);
  });
};

export const deleteRecentlyVisited = () => {
  withLocalStorage(localStorage => {
    localStorage.removeItem(LOCAL_STORAGE_KEY);
  });
};
